import type { IconData } from '@stacksjs/iconify-core'

export const phone: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M45 13c0-5.523-4.477-10-10-10h-.569a3 3 0 0 0-2.785 1.886L29.18 11.05a4 4 0 0 0 .885 4.314l3.077 3.077c.493.493.7 1.21.498 1.878a20.05 20.05 0 0 1-13.32 13.32c-.668.203-1.385-.005-1.878-.498l-3.077-3.077a4 4 0 0 0-4.314-.885l-6.165 2.466A3 3 0 0 0 3 34.43V35c0 5.523 4.477 10 10 10h.5c17.11 0 31.034-13.642 31.489-30.642q0-.008.005-.013a.02.02 0 0 0 .006-.013z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default phone
